<template>
  <div>
    <CRow class="content-fade-in">
      <CCol md="12">
        <CCard>
          <CCardBody>
            <CForm class="form-basic">
              <CRow>
                <CCol sm="6" md="6" xl="6">
                  <BaseInput :options="titleInput.options" :data="titleInput.data" />
                </CCol>
                <CCol sm="6" md="6" xl="6">
                  <div class="form-input-wrapper">
                    <div class="form-group">
                      <label class="form-label" for="uploadFile">Chọn tài liệu<span class='required'> *</span></label>
                      <div class="custom-file"
                        :class="selectedFiles.data.validator.isValid == false ? 'input-valid-error' : ''">
                        <input type="file" class="custom-file-input" id="uploadFile" ref="file"
                          accept=".doc, .docx, .pdf, .xls, .xlsx" @change="selectFile($event)">
                        <label class="custom-file-label" for="uploadFile">{{ fileName }}</label>
                      </div>
                      <div class="valid-error"
                        v-show="!(selectedFiles.data.validator ? selectedFiles.data.validator.isValid : true)">
                        {{ selectedFiles.data.validator ? selectedFiles.data.validator.errorMessage : "" }}
                      </div>
                    </div>
                  </div>
                </CCol>
                <CCol sm="12" md="12" xl="12">
                  <BaseTextArea :options="descriptionInput.options" :data="descriptionInput.data"
                    v-model="descriptionInput.data.model" />
                </CCol>
              </CRow>
              <div slot="footer" class="mt-4">
                <CButton color="primary" class="btn-action-primary mr-2" @click="submitData()">
                  <i class="fa fa-plus"></i> Lưu lại
                </CButton>
                <CButton color="secondary" class="btn-action-primary mr-2" @click="resetData()"><i
                    class="fa fa-eraser"></i> Làm mới
                </CButton>
              </div>
              <BaseLoading :loading="loading.value"></BaseLoading>
            </CForm>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import BaseSelect from "../base/BaseSelect2";
import BaseInput from "../base/BaseInput";
import BaseLoading from "../base/BaseFormLoading";
import BaseTextArea from "../base/BaseTextArea.vue";

export default {
  name: "DocumentAdd",
  components: { BaseSelect, BaseInput, BaseLoading, BaseTextArea },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Errors"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  data: function () {
    let that = this;
    return {
      loading: { value: false },
      fileName: 'Chọn tệp',
      titleInput: {
        options: {
          label: "Tiêu đề tài liệu <span class='required'>*</span>",
          placeholder: "Tiêu đề tài liệu",
          maxlength: 255
        },
        data: {
          name: "title",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.titleInput.data.model;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Tiêu đề tài liệu không được để trống";
              } else {
                this.isValid = true;
              }
              return this.isValid;
            }
          }
        }
      },
      descriptionInput: {
        options: {
          label: "Mô tả tài liệu",
          placeholder: "Mô tả tài liệu",
          maxlength: 2000,
          rows: 5
        },
        data: {
          name: "description",
          model: "",
          updateCallback: function () {
            that.submitData();
          }
        }
      },
      selectedFiles: {
        data: {
          name: "file",
          model: {
            fileName: '',
            content: '',
            size: '',
            type: ''
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.selectedFiles.data.model.fileName;
              if (value.length == 0) {
                this.isValid = false;
                this.errorMessage = "Tài liệu không được để trống";
              } else {
                let type = that.selectedFiles.data.model.type;
                if (type == "application/pdf" || type == "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  || type == "application/msword" || type == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || type == "application/vnd.ms-excel") {
                  this.isValid = true;
                  this.errorMessage = "";
                } else {
                  this.isValid = false;
                  this.errorMessage = "Sai định dạng tệp tin";
                }
              }
              return this.isValid;
            }
          }
        }
      }
    }
  },
  methods: {
    submitData: function () {
      let that = this;
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/document/add",
        dataRef: function () {
          return that.$data;
        },
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({ message: that.$helper.getStringError(response.data.data) });
            that.$helper.setupErrorModel(response.data.data, that.$data);
          } else {
            that.showSuccessMsg({
              message: "Thêm mới tài liệu thành công"
            });
            that.$router.push('/document-management/managed-document.html')
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    selectFile() {
      let that = this;
      let reader = new FileReader();
      var file = this.$refs.file.files[0];
      if (file) {
        that.fileName = file.name;
        reader.readAsDataURL(file);
        reader.onload = function () {
          setTimeout(function () {
            that.selectedFiles.data.model.fileName = file.name;
            that.selectedFiles.data.model.content = reader.result.split(',')[1];
            that.selectedFiles.data.model.type = file.type;
          }, 500)
        }
      }
    },
    resetData() {
      let that = this;
      that.$helper.setupDataResponse(that.$data, {});
    }
  },
  computed: {},
  created() {
  },
  mounted() {
  },
  watch: {
  }
};
</script>
